import React from 'react';
import { Flex,Icon,Progress, Button} from "antd-mobile";
import "./InvitationPage.scss";
import GoBack from "../../components/GoBack";
/**
 * 入职管理
 */
class InvitationPage extends React.Component{
    constructor(props){
        super(props);
        this.setState={

        };
    }


    render(){
        return (
        <div>123</div>
        )
    }
}
export default InvitationPage